import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="scroll-smooth font-sans">
      <Header />
      <Hero />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}
